var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.44,
    d: "M7.984 3.9h8.672c2.652 0 4.304 1.872 4.304 4.523v7.152c0 2.65-1.652 4.523-4.305 4.523H7.984c-2.654 0-4.303-1.873-4.303-4.523V8.423c0-2.65 1.658-4.523 4.303-4.523ZM3.68 8.64h17.28M8.715 8.636 6.518 4.123m6.462 4.513-2.32-4.732m6.592 4.732-2.32-4.732"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovie);
export default __webpack_public_path__ + "static/media/movie.3d8fd6778fa951aa2b7accb84f78f0ad.svg";
export { ForwardRef as ReactComponent };